{
  "quote": "AI-first engineering shifts value from writing code to making decisions."
}
